<template>
    <div class="columns">
        <div class="column is-7">
            <img height="100" width="100" src="../assets/error.png" alt="">
            <h1 class="is-size-1 has-text-weight-bold">{{title}}</h1>
            <p class="is-size-5" v-html="message"></p>
            <small v-if="errorText" class="is-size-7">Error Message : {{errorText}}</small>
        </div>
        <div class="column is-5 has-text-right">
            <img width="200" src="../assets/product_lassi.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    title: {
      type: String,
      default: "Error"
    },
    errorText: {
      type: String,
      default: "Error"
    },
    message: {
      type: String,
      default: "An error occured."
    }
  }
};
</script>

<style lang="scss">
.is-link {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/routes/Error.vue